import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { MyGroupTherapies } from "@/components/group-therapy/MyGroupTherapies";

export const Route = createFileRoute("/dashboard/client/group-therapies")({
  component: ClientGroupTherapies,
});

function ClientGroupTherapies() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-4xl space-y-8">
      <div>
        <h1
          className="text-2xl font-bold text-foreground"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {t("clientGroupTherapies.title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("clientGroupTherapies.subtitle")}
        </p>
      </div>

      <MyGroupTherapies />
    </div>
  );
}
